// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// MTD Reports
const MtdReportBase = () => import('@/modules/reports/views/MTD/MtdReportBase')
const MtdReport = () => import('@/modules/reports/views/MTD/MtdReport')
const CloserInstallRateReport = () => import('@/modules/reports/views/MTD/CloserInstallRateReport')
const TerminalMonthlyRateAvgReport = () => import('@/modules/reports/views/MTD/TerminalMonthlyRateAvgReport')
const MidTidGraph = () => import('@/modules/reports/views/MTD/MidTidGraph')
const CloserTIDSalesReport = () => import('@/modules/reports/views/MTD/CloserTIDSalesReport')
const CloserAvgMonthlyRateReport = () => import('@/modules/reports/views/MTD/CloserAvgMonthlyRateReport')
const TerminalSalesReport = () => import('@/modules/reports/views/MTD/TerminalSalesReport')
const CloserMIDSalesReport = () => import('@/modules/reports/views/MTD/CloserMIDSalesReport')
const MTDSummary = () => import('@/modules/reports/views/MTD/MTDSummary')
const CloserAvgMonthlyIcPlusRateReport = () => import('@/modules/reports/views/MTD/CloserAvgMonthlyIcPlusRateReport')
const PendsReport = () => import('@/modules/reports/views/MTD/PendsReport')
const CashAdvanceReportPage = () => import('@/modules/reports/views/CashAdvance/CashAdvanceReportPage')
const CashAdvanceReport = () => import('@/modules/reports/views/CashAdvance/CashAdvanceReport')
const CashAdvanceLeadsReport = () => import('@/modules/reports/views/CashAdvance/CashAdvanceLeadsReport')

const LeadGenReportPage = () => import('@/modules/reports/views/LeadGenReportPage')
const LeadGenReport = () => import('@/modules/reports/views/LeadGenReport')
const LeadGenTotalTransferReport = () => import('@/modules/reports/views/LeadGenTotalTransferReport')
const LeadGenWeeklyTransferReport = () => import('@/modules/reports/views/LeadGenWeeklyTransferReport')
const LeadGenWeeklyTransferOpenerReport = () => import('@/modules/reports/views/LeadGenWeeklyTransferOpenerReport')
const LeadGenConversionByRep = () => import('@/modules/reports/views/LeadGenConversionByRep')
const LeadGenPreviouslyInterestedReport = () => import('@/modules/reports/views/LeadGenPreviouslyInterestedReport')
const OpenerPerformanceTrendReport = () => import('@/modules/reports/views/OpenerPerformanceReport')
const CloserSuccessReport = () => import('@/modules/reports/views/CloserSuccessReport')

// CS Reporting
const CSReportPage = () => import('@/modules/reports/views/CSReportPage')
const CSStats = () => import('@/modules/reports/views/CSStats')
const CSTicketReport = () => import('@/modules/reports/views/CSTicketReport')
const CSTicketResponseTime = () => import('@/modules/reports/views/CSTicketResponseTime')
const CSFollowUpCalls = () => import('@/modules/reports/views/CSFollowUpCalls')
const CSTicketAgeGraph = () => import('@/modules/reports/views/CSTicketAgeGraph')

// Docusign
const DocusignPage = () => import('@/modules/reports/views/DocusignPage')
const DocusignStats = () => import('@/modules/reports/views/DocusignStats')

// Install Reporting
const InstallReportPage = () => import('@/modules/reports/views/InstallReportPage')
const InstallCompanyReport = () => import('@/modules/reports/views/InstallCompanyReport')
const InstallUserReport = () => import('@/modules/reports/views/InstallUserReport')
const DetailedTrainedReport = () => import('@/modules/reports/views/DetailedTrainedReport')
const InstallMonthlyReport = () => import('@/modules/reports/views/InstallMonthlyReport')
const InstallDeploymentReport = () => import('@/modules/reports/views/InstallDeploymentReport')

// Admin Reporting
const AdminMtdReport = () => import('@/modules/reports/views/MTD/AdminMtdReport')
const AdminCloserReport = () => import('@/modules/reports/views/AdminCloserReport')
const AdminContactReport = () => import('@/modules/reports/views/AdminContactReport')
const AdminClientsTransactionsReport = () => import('@/modules/reports/views/AdminClientsTransactionsReport')
const AdminMonthlyDebitTxnReport = () => import('@/modules/reports/views/AdminMonthlyDebitTxnReport')

// Nuvei Funding Report
const NuveiFundingReport = () => import('@/modules/reports/views/NuveiFundingReport')

const CallDataSummaryBase = () => import('@/modules/reports/views/CallDataSummary/Base') 
const CallDataSummaryStats = () => import('@/modules/reports/views/CallDataSummary/Stats')
const CallDataSummaryOutbound = () => import('@/modules/reports/views/CallDataSummary/Outbound')
const SalesCallStats = () => import('@/modules/reports/views/CallDataSummary/SalesCallStats')

// Taliup Reporting
const TaliupOrderReport = () => import('@/modules/reports/views/TaliupOrderReport')

// Retention Reporting
const RetentionReportPage = () => import('@/modules/reports/views/RetentionReportPage')
const RetentionReport = () => import('@/modules/reports/views/RetentionReport')
const RetentionSavesByDay = () => import('@/modules/reports/views/RetentionSavesByDay')
const RetentionCancellationReasonReport = () => import('@/modules/reports/views/RetentionCancellationReasonReport')

// Report Builder
const ReportBuilder = () => import('@/modules/reports/views/ReportBuilder')
const RetentionMonthlySummaryReport = () => import('@/modules/reports/views/RetentionMonthlySummaryReport')

// Campaign Reporting
const CampaignReportPage = () => import('@/modules/reports/views/CampaignReportPage')
const CampaignRecycledPerAgent = () => import('@/modules/reports/views/CampaignRecycledPerAgent')

// Commission Reporting
const OrderCommissionReport = () => import('@/modules/reports/views/OrderCommissionReport')

// PPSA Reporting
const PpsaSummary = () => import('@/modules/reports/views/PPSA/PpsaSummary')
const PpsaDetail = () => import('@/modules/reports/views/PPSA/PpsaDetail')


var routes = [
  {
    path: '/reports',
    name: 'Reports',
    component: DefaultContainer,
    children: [
		{
			path: '/reports/mtd/mtd-list',
			name: 'MtdReportBase',
			redirect: '/reports/mtd/mtd-list',
			component: MtdReportBase,
			children: [
				{
					path: '/reports/mtd/mtd-list',
					name: 'MtdReport',
					component: MtdReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-list',
					},
				},
				{
					path: '/reports/mtd/closer-install-rate',
					name: 'CloserInstallRateReport',
					component: CloserInstallRateReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-closer-install-rate',
					},
				},
				{
					path: '/reports/mtd/closer-tid-sales',
					name: 'CloserTIDSalesReport',
					component: CloserTIDSalesReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-closer-tid-sales',
					},
				},
				{
					path: '/reports/mtd/closer-avg-monthly-rate',
					name: 'CloserAvgMonthlyRateReport',
					component: CloserAvgMonthlyRateReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-closer-avg-monthly-rate',
					},
				},
				{
					path: '/reports/mtd/terminal-report',
					name: 'TerminalSalesReport',
					component: TerminalSalesReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-terminal-sales',
					},
				},
				{
					path: '/reports/mtd/closer-mid-sales',
					name: 'CloserMIDSalesReport',
					component: CloserMIDSalesReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-closer-mid-sales',
					},
				},
				{

					path: '/reports/mtd/terminal-monthly-rate-avg',
					name: 'TerminalMonthlyRateAvgReport',
					component: TerminalMonthlyRateAvgReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-terminal-monthly-rate-avg',
					},
				},
				{
					path: '/reports/mtd/mid-tid-graph',
					name: 'MidTidGraph',
					component: MidTidGraph,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mid-tid-graph',
					},
				},
				{
					path: '/reports/mtd/mtd-summary',
					name: 'MTDSummary',
					component: MTDSummary,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'mtd-summary',
					},
				},
				{
					path: '/reports/mtd/closer-ic-plus-rate',
					name: 'CloserAvgMonthlyIcPlusRateReport',
					component: CloserAvgMonthlyIcPlusRateReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'closer',
						tab: 'mtd-closer-ic-plus-rate',
					},
				},
				{
					path: '/reports/mtd/ppsa-summary',
					name: 'PpsaSummary',
					component: PpsaSummary,
					meta: {
					requiresAuth: true,
					permission: false,
					tab: 'mtd-ppsa-summary',
					},
				},
				{
					path: '/reports/mtd/ppsa-detail',
					name: 'PpsaDetail',
					component: PpsaDetail,
					meta: {
					requiresAuth: true,
					permission: false,
					tab: 'mtd-ppsa-details',
					},
				},
				{
					path: '/reports/mtd/pends-report',
					name: 'PendsReport',
					component: PendsReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'mtd-pends-report',
					},
				},
			]
		},
		{
			path: '/reports/cash-advance',
			redirect: '/reports/cash-advance/orders',
			name: 'CashAdvanceReportPage',
			component: CashAdvanceReportPage,
			children: [
				{
					path: '/reports/cash-advance/orders',
					name: 'CashAdvanceReport',
					component: CashAdvanceReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'ca-orders',
					},
				},
				{
					path: '/reports/cash-advance/leads',
					name: 'CashAdvanceLeadsReport',
					component: CashAdvanceLeadsReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'ca-leads',
					},
				},
			]
		},
		{
			path: '/reports/lead-gen',
			redirect: '/reports/lead-gen/list',
			name: 'LeadGenReportPage',
			component: LeadGenReportPage,
			children: [
				{
					path: '/reports/lead-gen/list',
					name: 'LeadGenReport',
					component: LeadGenReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'opener',
						tab: 'lead-gen'
					},
				},
				{
					path: '/reports/lead-gen/transfer',
					name: 'LeadGenTotalTransferReport',
					component: LeadGenTotalTransferReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'opener',
						tab: 'lead-gen-transfer'
					},
				},
				{
					path: '/reports/lead-gen/weekly-transfer',
					name: 'LeadGenWeeklyTransferReport',
					component: LeadGenWeeklyTransferReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'opener',
						tab: 'lead-gen-weekly-transfer'
					},
				},
				{
					path: '/reports/lead-gen/weekly-transfer-opener',
					name: 'LeadGenWeeklyTransferOpenerReport',
					component: LeadGenWeeklyTransferOpenerReport,
					meta: {
						requiresAuth: true,
						permission: false,
						role_filter: 'opener',
						tab: 'lead-gen-weekly-transfer'
					},
				},
				{
					path: '/reports/lead-gen/conversion-by-rep/:agentType',
					name: 'LeadGenConversionByRep',
					component: LeadGenConversionByRep,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'lead-gen-conversion-by-rep'
					},
				},
				{
					path: '/reports/lead-gen/previously-interested/:agentType',
					name: 'LeadGenPreviouslyInterestedReport',
					component: LeadGenPreviouslyInterestedReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'lead-gen-previously-interested'
					},
				},
				{
					path: '/reports/lead-gen/opener-performance-trend',
					name: 'OpenerPerformanceTrendReport',
					component: OpenerPerformanceTrendReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'lead-gen-opener-performance-trend',
					},
				},
			]
		},
		{
			path: '/reports/closer-success',
			name: 'CloserSuccessReport',
			component: CloserSuccessReport,
			meta: {
				requiresAuth: true,
				permission: false,
			},
		},
		{
			path: '/reports/customer-service',
			redirect: '/reports/customer-service/stats',
			name: 'CSReportPage',
			component: CSReportPage,
			children: [
				{
					path: '/reports/customer-service/stats',
					name: 'CSStats',
					component: CSStats,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'cs-stats'
					},
				},
				{
					path: '/reports/customer-service/ticket-report',
					name: 'CSTicketReport',
					component: CSTicketReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'cs-ticket-report'
					},
				},
				{
					path: '/reports/customer-service/ticket-response-time',
					name: 'CSTicketResponseTime',
					component: CSTicketResponseTime,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'cs-ticket-response-time'
					},
				},
				{
					path: '/reports/customer-service/follow-up-calls',
					name: 'CSFollowUpCalls',
					component: CSFollowUpCalls,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'cs-follow-up-calls',
						role_filter: 'customer_service_agent',
					},
				},
				{
					path: '/reports/customer-service/ticket-age-graph',
					name: 'CSTicketAgeGraph',
					component: CSTicketAgeGraph,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'ticket-age-graph',
						role_filter: 'customer_service_agent',
					},
				},
			]
		},
		{
			path: '/reports/docusign',
			name: 'DocusignPage',
			redirect: '/reports/docusign/stats',
			component: DocusignPage,
			children: [
				{
					path: '/reports/docusign/stats',
					name: 'Docusign Report',
					component: DocusignStats,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'stats',
					},
				},
			]
		},
		{
			path: '/reports/installs',
			redirect: '/reports/installs/company',
			name: 'InstallReportPage',
			component: InstallReportPage,
			children: [
				{
					path: '/reports/installs/company',
					name: 'InstallCompanyReport',
					component: InstallCompanyReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'installs-company'
					},
				},
				{
					path: '/reports/installs/user',
					name: 'InstallUserReport',
					component: InstallUserReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'installs-user'
					},
				},
				{
					path: '/reports/install/detailed-trained',
					name: 'DetailedTrainedReport',
					component: DetailedTrainedReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'detailed-trained-report',
						role_filter: 'installation_rep',
					},
				},
				{
					path: '/reports/install/monthly',
					name: 'InstallMonthlyReport',
					component: InstallMonthlyReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'monthly-report',
						role_filter: 'installation_rep',
					},
				},
				{
					path: '/reports/install/deployment',
					name: 'InstallDeploymentReport',
					component: InstallDeploymentReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'deployment-report',
						role_filter: 'installation_rep',
					},
				},
			]
		},
		{
			path: '/reports/nuvei-funding',
			name: 'NuveiFundingReport',
			component: NuveiFundingReport,
			meta: {
				requiresAuth: true,
				permission: false,
			},
		},
		{
			path: '/reports/call-data-summary',
			name: 'CallDataSummaryBase',
			redirect: '/reports/call-data-summary/stats',
			component: CallDataSummaryBase,
			children: [
				{
					path: '/reports/call-data-summary/stats',
					name: 'CallDataSummaryStats',
					component: CallDataSummaryStats,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'call-data-summary-stats',
					},
				},
				{
					path: '/reports/call-data-summary/outbound',
					name: 'CallDataSummaryOutbound',
					component: CallDataSummaryOutbound,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'call-data-summary-outbound',
					},
				},
				{
					path: '/reports/call-data-summary/sales-call-stats',
					name: 'SalesCallStats',
					component: SalesCallStats,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'call-data-summary-sales-call-stats',
					},
				},
			]
		},
		{
			path: '/reports/taliup',
			name: 'TaliupOrderReport',
			component: TaliupOrderReport,
			meta: {
				requiresAuth: true,
				permission: false,
				role_filter: 'closer',
			},
		},
		{
			path: '/reports/order-commission',
			name: 'OrderCommissionReport',
			component: OrderCommissionReport,
			meta: {
				requiresAuth: true,
				permission: false,
				role_filter: 'closer',
			},
		},
		{
			path: '/reports/campaign',
			redirect: '/reports/campaign/leads-recycled-per-agent/opener',
			name: 'CampaignReportPage',
			component: CampaignReportPage,
			children: [
				{
					path: '/reports/campaign/leads-recycled-per-agent/:agentType',
					name: 'CampaignRecycledPerAgent',
					component: CampaignRecycledPerAgent,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'leads-recycled-per-agent'
					},
				},
			]
		},
		{
			path: '/reports/retention',
			name: 'RetentionReportPage',
			component: RetentionReportPage,
			children: [
				{
					path: '/reports/retention',
					name: 'RetentionReport',
					component: RetentionReport,
					meta: {
					requiresAuth: true,
					permission: false,
					tab: 'retention-report',
					role_filter: 'customer_service_agent',
					},
				},
				{
					path: '/reports/retention/saves-by-day',
					name: 'RetentionSavesByDay',
					component: RetentionSavesByDay,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'retention-saves-by-day',
						role_filter: 'customer_service_agent',
					},
				},
				{
					path: '/reports/retention/monthly-summary',
					name: 'RetentionMonthlySummaryReport',
					component: RetentionMonthlySummaryReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'retention-monthly-summary',
						role_filter: 'customer_service_agent',
					},
				},
				{
					path: '/reports/retention/cancellation',
					name: 'RetentionCancellationReasonReport',
					component: RetentionCancellationReasonReport,
					meta: {
						requiresAuth: true,
						permission: false,
						tab: 'retention-cancellation-reason-report',
						role_filter: 'customer_service_agent',
					},
				},
			]
		},
		{
			path: '/reports/builder',
			name: 'ReportBuilder',
			component: ReportBuilder,
			meta: {
			requiresAuth: true,
			permission: false,
			},
		},
		]
	},
	{
		path: '/admin-reports/mtd',
		redirect: '/admin-reports/mtd',
		name: 'AdminReports',
		component: DefaultContainer,
		children: [
			{
				path: '/admin-reports/mtd',
				name: 'AdminMtdReport',
				component: AdminMtdReport,
				meta: {
					requiresAuth: true,
					permission: false,
					role_filter: 'closer',
				},
			},
			{
				path: '/admin-reports/closer',
				name: 'AdminCloserReport',
				component: AdminCloserReport,
				meta: {
					requiresAuth: true,
					permission: false,
				},
			},
			{
				path: '/admin-reports/contact-report',
				name: 'AdminContactReport',
				component: AdminContactReport,
				meta: {
					requiresAuth: true,
					permission: false,
				},
			},
			{
				path: '/admin-reports/clients-latest-txn',
				name: 'AdminClientsTransactionsReport',
				component: AdminClientsTransactionsReport,
				meta: {
					requiresAuth: true,
					permission: false,
				},
			},
			{
				path: '/admin-reports/monthly-debit-txn',
				name: 'AdminMonthlyDebitTxnReport',
				component: AdminMonthlyDebitTxnReport,
				meta: {
					requiresAuth: true,
					permission: false,
				},
			},

		]
	},
];


export default routes;
